import { Col, Label, ReactSelectBox } from "client/CommonComponents";
import { useMemo } from "react";

const Mower = (props?: any) => {
  const {
    handleSelectionChange,
    managedEquipmentValues,
    manufacturerDropDownList,
    categoryDropdownList,
    deckSizeDropDownList,
    deckTypeDropDownList,
    stateAvailabilityDropDownList,
    annualHoursDropDownList,
    autonomousDropDownList,
    programStatusDropDownList,
    managedMowerRef
  } = props

  const stateAvailabilityValue:any = useMemo(() => {
    return  stateAvailabilityDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.stateAvailabilityId)
  }, [managedEquipmentValues?.stateAvailabilityId, stateAvailabilityDropDownList])

  const manufacturerValue:any = useMemo(() => {
    return  manufacturerDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.manufacturerId)
  }, [managedEquipmentValues?.manufacturerId, manufacturerDropDownList])

  const programStatusValue:any = useMemo(() => {
    return  programStatusDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.programStatusId)
  }, [managedEquipmentValues?.programStatusId, programStatusDropDownList])

  const annualHoursValue:any = useMemo(() => {
    return  annualHoursDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.annualHoursId)
  }, [managedEquipmentValues?.annualHoursId, annualHoursDropDownList])

  const categoryValue:any = useMemo(() => {
    return  categoryDropdownList?.find((i: any) => i?.key == managedEquipmentValues?.categoryId)
  }, [managedEquipmentValues?.categoryId, categoryDropdownList])

  const deckSizeValue:any = useMemo(() => {
    return  deckSizeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.deckSizeId)
  }, [managedEquipmentValues?.deckSizeId, deckSizeDropDownList])

  const deckTypeValue:any = useMemo(() => {
    return  deckTypeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.deckTypeId)
  }, [managedEquipmentValues?.deckTypeId, deckTypeDropDownList])

  const autonomousValue:any = useMemo(() => {
    return  autonomousDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.autonomousId)
  }, [managedEquipmentValues?.autonomousId, autonomousDropDownList])

  return (<>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label">State Availability</Label>
      <ReactSelectBox
        options={stateAvailabilityDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'stateAvailabilityId', 2)}
        value={stateAvailabilityValue}
        selectRef={(element: any) => managedMowerRef.current[1] = element}
       data-attribute="Mower_Default_SearchSelectBox" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_2">Manufacturer</Label>
      <ReactSelectBox
        options={manufacturerDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'manufacturerId', 3)}
        value={manufacturerValue}
        selectRef={(element: any) => managedMowerRef.current[2] = element}
       data-attribute="Mower_Default_SearchSelectBox_2" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_3">Program Status</Label>
      <ReactSelectBox
        options={programStatusDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'programStatusId', 4)}
        value={programStatusValue}
        selectRef={(element: any) => managedMowerRef.current[3] = element}
       data-attribute="Mower_Default_SearchSelectBox_3" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_4">Annual Hours</Label>
      <ReactSelectBox
        options={annualHoursDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'annualHoursId', 5)}
        value={annualHoursValue}
        selectRef={(element: any) => managedMowerRef.current[4] = element}
       data-attribute="Mower_Default_SearchSelectBox_4" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_5">Category</Label>
      <ReactSelectBox
        options={categoryDropdownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'categoryId', 6)}
        value={categoryValue}
        selectRef={(element: any) => managedMowerRef.current[5] = element}
       data-attribute="Mower_Default_SearchSelectBox_5" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_6">Deck Size</Label>
      <ReactSelectBox
        options={deckSizeDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'deckSizeId', 7)}
        value={deckSizeValue}
        selectRef={(element: any) => managedMowerRef.current[6] = element}
        isSearchable={true}
       data-attribute="Mower_Default_SearchSelectBox_6" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_7">Deck Type</Label>
      <ReactSelectBox
        options={deckTypeDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'deckTypeId', 8)}
        value={deckTypeValue}
        selectRef={(element: any) => managedMowerRef.current[7] = element}
       data-attribute="Mower_Default_SearchSelectBox_7" />
    </Col>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="Mower_Default_Label_8">Autonomous</Label>
      <ReactSelectBox
        options={autonomousDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'autonomousId')}
        value={autonomousValue}
        selectRef={(element: any) => managedMowerRef.current[8] = element}
       data-attribute="Mower_Default_SearchSelectBox_8" />
    </Col>
  </>)
}

export default Mower;
